import { Toolbar as TipTapToolbar } from "@circle-react-uikit/TipTapBlockEditor/Toolbar";
import { QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID } from "@circle-react/components/QuickPostV3/constants";
import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useTiptapBodyHandlers } from "@circle-react/components/QuickPostV3/hooks/useTiptapBodyHandlers";
import { FormTipTapBlockEditor } from "@circle-react/components/shared/uikit/Form/FormTipTapBlockEditor/FormTipTapBlockEditor";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCanRecordVoiceInPosts } from "@circle-react/hooks/useCanRecordVoiceInPosts";
import { useCanUploadMedia } from "@circle-react/hooks/useCanUploadMedia";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export const TipTap = () => {
  const { watch } = useFormContext<PostFormValues>();
  const isMediaUploadAllowed = useCanUploadMedia();
  const isVoiceMessageAllowed = useCanRecordVoiceInPosts();
  const spaceId = watch("space_id");
  const postName = watch("name");
  const {
    handleAttachmentsChange,
    handleSgidChange,
    inlineAttachments,
    sgidToObjectMap,
  } = useTiptapBodyHandlers();

  return (
    <FormTipTapBlockEditor
      placeholder={t("quick_post_v2.body_placeholder")}
      name="tiptap_body.body"
      toolbars={[
        {
          portalId: QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID,
          component: TipTapToolbar,
        },
      ]}
      className="h-full"
      editorClassName={classNames(
        "text-primary h-full text-base leading-6",
        anchorClassNames("quick-post-modal--v3"),
      )}
      spaceId={spaceId}
      sgidToObjectMap={sgidToObjectMap}
      inlineAttachments={inlineAttachments}
      onLocalSgidToObjectMapChange={handleSgidChange}
      onLocalAttachmentsChange={handleAttachmentsChange}
      aiCopilotTitle={postName ?? undefined}
      isVideoClipAllowed
      isVoiceMessageAllowed={isVoiceMessageAllowed}
      isMediaUploadAllowed={isMediaUploadAllowed}
    />
  );
};
